import React from 'react';
import { CheckIcon, GlobeIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
import { bonuses, MOCKUP_IMAGE, offerIncludes } from '../data/content';
export function Offer() {
  return <section id="offer" className="border-t border-line bg-panel px-4 py-16 sm:py-20" aria-labelledby="offer-title" data-id="element-192" data-mp="1hpqvo3zy112v">
      <div className="mx-auto max-w-2xl" data-id="element-193" data-mp="tz3ib379dj8x">
        <p className="text-center font-display text-lg font-bold uppercase tracking-wider text-amber" data-id="element-194" data-mp="p0a418k5do7p">
          Your special launch offer
        </p>
        <h2 id="offer-title" className="mt-2 text-center font-display text-4xl font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-195" data-mp="13yc8rm2x0fqj">
          Here’s everything you’ll receive today
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl border-2 border-amber bg-ink" data-id="element-196" data-mp="2add7fzjbrc0t">
          <img src={MOCKUP_IMAGE} alt="Complete OBD2 Diagnostic Blueprint collection" className="w-full bg-ink px-2 pt-4" data-id="element-197" data-mp="pk7gbmti0n9z" />

          <div className="p-5 sm:p-8" data-id="element-198" data-mp="uiselgp6wwvs">
            <ul className="divide-y divide-line border-y border-line" data-id="element-199" data-mp="uhqw4r5uh841">
              <li className="flex items-start justify-between gap-4 py-4" data-id="element-200" data-mp="zjg6s5p5njrl">
                <span className="text-[16px] font-bold text-white" data-id="element-201" data-mp="13jqebmslii8k">
                  OBD2 Diagnostic Blueprint™ — 6 Professional Volumes
                </span>
                <s className="shrink-0 font-semibold text-mist" data-id="element-202" data-mp="6rmpsc19uu9c">$97</s>
              </li>
              {bonuses.map(b => <li key={b.number} className="flex items-start justify-between gap-4 py-3.5" data-id="element-203" data-mp="fuffiaut2xx2">
                  <span className="text-[15px] text-white" data-id="element-204" data-mp="kl4aw19lwf1h">
                    <span className="font-bold text-signal" data-id="element-205" data-mp="kmp3hlcd1nwp">Bonus #{b.number}:</span> {b.title}
                  </span>
                  <s className="shrink-0 font-semibold text-mist" data-id="element-206" data-mp="3k6jcienbkhzy">${b.value}</s>
                </li>)}
            </ul>

            <div className="mt-6 text-center" data-id="element-207" data-mp="vf7dyi1mqicl">
              <p className="text-lg font-semibold text-mist" data-id="element-208" data-mp="ve5ym1dkz9p2">
                Total reference value: <s className="text-signal" data-id="element-209" data-mp="qfut22ubjlcn">$254</s>
              </p>
              <p className="mt-4 font-display text-xl font-bold uppercase text-white" data-id="element-210" data-mp="1561z1j353bwg">Today, get everything for just</p>
              <p className="font-display text-[104px] font-extrabold leading-[0.9] text-amber sm:text-[128px]" data-id="element-211" data-mp="107ie9m0a865o">
                $27
              </p>
              <p className="font-display text-xl font-bold uppercase tracking-wide text-white" data-id="element-212" data-mp="cipo666ccsiz">
                USD · One-time payment
              </p>
              <p className="mx-auto mt-4 flex max-w-sm items-center justify-center gap-2 rounded-full bg-panel2 px-4 py-2 text-sm font-semibold text-white" data-id="element-213" data-mp="lich03l08q0f">
                <GlobeIcon className="h-4 w-4 shrink-0 text-ok" aria-hidden="true" data-id="element-214" data-mp="1wwg91481842u" />
                Currency is converted automatically to yours
              </p>
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-215" data-mp="1sxh6trdoqlf3">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-white" data-id="element-216" data-mp="25dqmnwmydovs">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-217" data-mp="25bdyv2uikkat" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-7" data-id="element-218" data-mp="1vhnd45prunyt">
              <ScarcityBar data-id="element-219" data-mp="2j4lpar6uz9qx" />
            </div>

            <div className="mt-7 space-y-8" data-id="element-220" data-mp="2j5x3lkxxjzwa">
              <CtaButton label="Yes! Give me instant access" sub="One-Time Payment · Instant Download · Lifetime Access" data-id="element-221" data-mp="2o3yj5vw5dh30" />
              <CountdownTimer data-id="element-222" data-mp="29d958lraxnvg" />
            </div>

            <div className="mt-7 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-mist" data-id="element-223" data-mp="2edn9dsps8do7">
              <span className="flex items-center gap-1.5" data-id="element-224" data-mp="3237qe62dl0uu">
                <LockIcon className="h-4 w-4 text-ok" aria-hidden="true" data-id="element-225" data-mp="36ug1d6jcsua4" /> Secure checkout
              </span>
              <span className="flex items-center gap-1.5" data-id="element-226" data-mp="1j6xpjjqokl2t">
                <ShieldCheckIcon className="h-4 w-4 text-ok" aria-hidden="true" data-id="element-227" data-mp="1j4bgtgs1zzj0" /> 7-day money-back guarantee
              </span>
            </div>
          </div>
        </div>

        <p className="mt-5 text-center text-xs leading-relaxed text-mist/80" data-id="element-228" data-mp="198qjvx1udpg4">
          Reference values are suggested individual component values for this offer.
        </p>
      </div>
    </section>;
}